<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;"><s-header-top></s-header-top></el-header>
			<el-header class="header"><s-header></s-header></el-header>
			<el-main>
				<div class="content">
					<el-row type="flex" justify="space-between">
						<el-col :span="12">
							<el-breadcrumb separator-class="el-icon-arrow-right">
								<span style="float: left;">当前位置：</span>
								<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
								<el-breadcrumb-item :to="{ path: '/product' }">服务产品</el-breadcrumb-item>
							</el-breadcrumb>
						</el-col>
						<el-col :span="6">
							<el-input placeholder="输入关键字" v-model="title" @change="getProductList"><el-button slot="append" icon="el-icon-search"></el-button></el-input>
						</el-col>
					</el-row>

					<div class="page table">
						<div class="lists">
							<div class="list" v-for="(item, index) in productList" :key="index">
								<div class="list_content" @click="goDetail(item)">
									<el-image class="img" :src="item.image ? imgPath(item.image) : require('../../static/p.jpg')" fit="contain"></el-image>
									<div class="info">
										<div class="name">{{ item.name }}</div>
										<div class="price">￥{{ item.price }}起</div>
									</div>
								</div>
								<div class="buttons">
									<div class="buy" @click="buy(item)">
										<i class="el-icon-shopping-cart-full"></i>
										订购
									</div>
									<div class="call" @click="call('订购热线', item.telephone)">
										<i class="el-icon-chat-dot-round"></i>
										联系我
									</div>
								</div>
							</div>
						</div>
						<pagination v-show="pageTotal>0" :total="pageTotal" :page.sync="currentPage" :limit.sync="pageSize" @pagination="getProductList" />
					</div>
					<!-- 输入金额dialog -->
					<el-dialog title="请输入金额" :visible.sync="outerVisible">
						<!-- 二维码dialog -->
						<el-dialog title="扫码支付" :visible.sync="dialogVisible" width="30%" append-to-body>
							<span style="text-align: center;display: block;"><img style="width: 340px;height: 340px;" :src="QRcode" /></span>
							<span style="text-align: center;display: block;margin-top: 10px;">扫码支付{{ ruleForm.money }}元</span>
							<span slot="footer" class="dialog-footer">
								<el-button @click="dialogVisible = false">取 消</el-button>
								<el-button @click="toOrder()">已支付</el-button>
							</span>
						</el-dialog>
						<!-- 输入金额表单 -->
						<el-form :model="ruleForm" :rules="rules" ref="ruleFrom">
							<el-form-item label="支付金额" label-width="120px" prop="money">
								<el-input v-model="ruleForm.money" autocomplete="off" style="width: 400px;"></el-input>
							</el-form-item>
							<i class="el-icon-warning-outline" style="color: #ffaa00;margin-left: 120px;"></i>
							<span>温馨提示：具体订购价格，请咨询确认。</span>
						</el-form>
						<div slot="footer" class="dialog-footer">
							<el-button @click="outerVisible = false">取 消</el-button>
							<el-button type="primary" @click="toWechatPay()">去支付</el-button>
						</div>
					</el-dialog>
				</div>
			</el-main>
			<el-footer class="footer"><s-footer></s-footer></el-footer>
			<el-footer class="copy-right"><s-copyRight></s-copyRight></el-footer>
		</el-scrollbar>
	</el-container>
</template>

<script>
import sHeaderTop from '@/components/header_top';
import sHeader from '@/components/header';
import sFooter from '@/components/footer';
import sCopyRight from '@/components/copy-right';
import Pagination from '@/components/Pagination';
import { productList, buyProduct } from '@/api';
import store from '@/store/index.js';
export default {
	name: 'product',
	components: {
		sHeaderTop,
		sHeader,
		sFooter,
		sCopyRight,
		Pagination
	},
	data() {
		var validateMoney = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入金额'));
			} else if (!/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value)) {
				return callback(new Error('请输入正确的金额'));
			} else if (value < this.item.price) {
				return callback(new Error('不能低于起始价格'));
			} else {
				callback();
			}
		};
		return {
			title: '',
			// 当前页数
			currentPage: 1,
			// 每页默认显示条数
			pageSize: 8,
			// 总条数
			pageTotal: 0,
			outerVisible: false, //输入价格dialog
			dialogVisible: false, //微信二维码支付dialog
			QRcode: '', //支付二维码
			orderId: '', //支付订单号
			productList: [],
			item: null, //当前订购的产品
			ruleForm: {
				money: 0.0 //支付金额
			},
			rules: {
				money: [{ validator: validateMoney, trigger: 'blur' }]
			}
		};
	},
	mounted() {
		if (this.$route.query.keyWord) {
			this.title = this.$route.query.keyWord;
		}
		this.getProductList();
	},
	methods: {
		//获取产品列表
		getProductList() {
			let _this = this;
			productList({
				pageNo: _this.currentPage,
				pageSize: _this.pageSize,
				title: _this.title
			}).then(res => {
				_this.productList = res.data.list;
				_this.pageTotal = res.data.count;
			});
		},
		//点击定购弹出输入价格dialog，若未登录提醒先登录
		buy(item) {
			if (store.state.isLogin) {
				this.outerVisible = true;
				this.item = item;
				this.ruleForm.money = item.price;
			} else {
				this.$confirm('购买产品需要先登录, 是否登录?', '提示', {
					confirmButtonText: '去登陆',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						this.toWxAuthorization();
					})
					.catch(() => {});
			}
		},
		//弹出微信支付 并请求展示二维码
		toWechatPay() {
			let _this = this;
			_this.$refs['ruleFrom'].validate((valid) => {
				if (valid) {
					_this.dialogVisible = true;
					buyProduct({
						cnts: 1,
						type: 'PC',
						productID: _this.item.id,
						money: _this.ruleForm.money
					}).then(res => {
						_this.QRcode = _this.$imgBaseUrl + res.data.imgUrl;
						_this.orderId = res.data.orderNo;
						// _this.dialogVisible = true;
					});
				}
			});
		},
		//支付完成，跳转至订单页面
		toOrder() {
			let routeUrl = this.$router.resolve({
				path: '/orderDetail', //跳转的路径
				query: {
					//路由传参时push和query搭配使用 ，作用时传递参数
					id: this.orderId
				}
			});
			window.open(routeUrl.href, '_blank');
		},
		//登录
		toWxAuthorization(){		
			window.location.href ="https://open.weixin.qq.com/connect/qrconnect?appid=wx8683c33354eeddb1&redirect_uri=https://xyqyfw.com/sovo/product&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e#wechat_redirect"
		},
		//图片地址
		imgPath(oldPath) {
			return this.$imgBaseUrl + oldPath;
		},
		//打电话弹框
		call(title, phone) {
			this.$alert(phone ? phone : '暂未提供', title, {
				confirmButtonText: '确定',
				callback: action => {}
			});
		},
		//跳转至产品详情
		goDetail(item) {
			let routeUrl = this.$router.resolve({
				path: '/productDetail', //跳转的路径
				query: {
					//路由传参时push和query搭配使用 ，作用时传递参数
					id: item.id
				}
			});
			window.open(routeUrl.href, '_blank');
		}
	}
};
</script>

<style lang="scss" scoped>
.page {
	min-height: 618px; /*若没有tabs56  height524 若有height468 */
}
.table {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-left: 20px;
	padding-right: 20px;
	margin-bottom: 20px;
}
.lists {
	width: 100%;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}
.list {
	/* height: 320px; */
	width: 250px;
	border: 1px solid #cccccc;
	margin-left: 15px;
	margin-right: 15px;
	margin-bottom: 30px;
	position: relative;
}
.list_content {
	cursor: pointer;
}
.img {
	height: 248px;
	padding: 10px;
	width: 100%;
}

.info {
	margin-left: 10px;
	margin-right: 10px;
}

.buttons {
	display: flex;
	flex-direction: row;
}
.buy,
.call {
	height: 48px;
	width: 50%;
	background-color: #f5f5f5;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 600;
	cursor: pointer;
}
.buy {
	border-right: 1px solid #dddddd;
}

.name {
	height: 26px;
	line-height: 26px;
	font-weight: 600;
	text-overflow: -o-ellipsis-lastline;
	letter-spacing: 1px;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}
.price {
	line-height: 30px;
	height: 30px;
	color: #ee3438;
	font-weight: 600;
}
.buttons i {
	font-size: 25px;
	margin-right: 5px;
}
.el-icon-shopping-cart-full {
	color: #ee3438;
}
.el-icon-chat-dot-round {
	color: #409eff;
}
.buy .el-button {
	background: #f5f5f5;
	border: none;
	padding: 0;
}
.el-dialog__body {
	text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/views/product.vue